module.exports = __webpack_public_path__ + "static/8-da7cc9b897794b1d16e093c24dde2f11.jpg";